import { Component, EventEmitter, inject, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { Button } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { Password } from 'primeng/password';
import { AuthService } from '../../../../services/auth/auth-service';
import { passwordValidator } from '../../../../validators/form-validation.validator';

@Component({
  selector: 'app-change-password-form',
  imports: [ReactiveFormsModule, DialogModule, Password, Button],
  templateUrl: './change-password-form.html',
  styleUrl: './change-password-form.scss'
})
export class ChangePasswordForm implements OnInit {

  passwordChecks = {
    lower: false,
    upper: false,
    digit: false,
    special: false,
    length: false
  };

  @Output() changedPassword = new EventEmitter();
  @Output() visibilityChange: EventEmitter<boolean> = new EventEmitter<boolean>();

  @Input()
  public get visibility() {
    return this._visibility
  }

  public set visibility(value: boolean) {
    this._visibility = value
    this.visibilityChange.emit(value)
  }

  changePasswordForm: FormGroup
  _visibility = false
  loading = false
  isSubmitted = false
  formErrors: Record<string, string> = {};

  private authService = inject(AuthService)
  private formBuilder = inject(FormBuilder)

  ngOnInit() {
    this.initUpdateEmployeeForm()
  }

  private initUpdateEmployeeForm = () => {
    this.changePasswordForm = this.formBuilder.group({
      oldPassword: ['', [Validators.required]],
      newPassword: ['', [Validators.required, Validators.minLength(8), passwordValidator()]],
      confirmPassword: ['', [Validators.required]],
    })
    this.checkPasswordValidation()
  }

  changepassword = () => {
    this.isSubmitted = true
    this.loading = true
    this.formErrors = {}
    if (this.changePasswordForm.invalid) {
      this.loading = false
      return
    }
    const payload = {
      oldPassword: this.changePasswordForm.value.oldPassword,
      newPassword: this.changePasswordForm.value.newPassword,
      confirmPassword: this.changePasswordForm.value.confirmPassword,
    }
    this.authService.changePassword(payload).subscribe({
      next: () => {
        this.changedPassword.emit()
        this.isSubmitted = false
        this.loading = false
        this.changePasswordForm.reset()
      },
      error: (err) => {
        this.loading = false
        if (err.status === 400) {
          const errorData = err.error.data
          this.formErrors = { ...errorData }
        }
      }
    })
  }

  cancel = () => {
    this.visibilityChange.emit(false)
  }

  checkPasswordValidation = () => {
    this.changePasswordForm.get('newPassword')?.valueChanges.subscribe(() => {
      this.checkPasswords();
      this.updatePasswordChecks();
    });

    this.changePasswordForm.get('confirmPassword')?.valueChanges.subscribe(() => {
      this.checkPasswords();
    });
  }

  checkPasswords = () => {
    const newPassword = this.changePasswordForm.get('newPassword')?.value;
    const confirmPassword = this.changePasswordForm.get('confirmPassword')?.value;

    if (newPassword === confirmPassword) {
      this.changePasswordForm.get('confirmPassword')?.setErrors(null)
    } else {
      this.changePasswordForm.get('confirmPassword')?.setErrors({ passwordMismatch: true })
    }
  }

  updatePasswordChecks = () => {
    const value = this.changePasswordForm.get('newPassword')?.value || '';

    this.passwordChecks.lower = /[a-z]/.test(value);
    this.passwordChecks.upper = /[A-Z]/.test(value);
    this.passwordChecks.digit = /\d/.test(value);
    this.passwordChecks.special = /[^A-Za-z0-9]/.test(value);
    this.passwordChecks.length = value.length >= 8;
  }

  preventPaste = (event: ClipboardEvent) => {
    event.preventDefault();
  }
}
